import styled from '@emotion/styled';
import { colors, Spinner, Text } from '@innovationdepartment/proxima-ui';
import React from 'react';
import InfiniteScroll from 'ui/InfiniteScroll';
import type { TaxonomyChangeModalViewProps } from './types';

const TaxonomiesWrapper = styled.div<{ center?: boolean }>`
  display: flex;
  flex-direction: column;
  position: relative;
  gap: 4px;
  padding: 0 0 16px;
  overflow-y: auto;
  min-height: 300px;
  max-height: 500px;
  ${({ center }) => center && `align-items: center; padding-top: 100px;`}
`;

const TaxonomyWrapper = styled.div`
  padding: 4px 12px;
  border-radius: 4px;
  cursor: pointer;

  &:hover {
    background: ${colors.neutral5};
  }

  transition: background 0.1s ease;
`;

const BrandProductsTaxonomyChangeModalTaxonomyList = (props: TaxonomyChangeModalViewProps) => {
  const { taxonomies, loading, onTaxonomyClick, onFetchTaxonomies } = props;

  if (!taxonomies.length) {
    return (
      <TaxonomiesWrapper center>
        <Text variant="body2" color="neutral40">
          Try searching for a different category
        </Text>
      </TaxonomiesWrapper>
    );
  }

  return (
    <TaxonomiesWrapper>
      {taxonomies.map((taxonomy, index) => (
        <React.Fragment key={taxonomy.id}>
          <TaxonomyWrapper onClick={() => onTaxonomyClick(taxonomy.id)}>
            <Text variant="body3Semibold" color="neutral80">
              {taxonomy.hierarchy.slice(0, -1).join(' > ')} {' > '}
            </Text>
            <Text variant="body2Semibold" color="red30">
              <strong>{taxonomy.hierarchy.at(-1)}</strong>
            </Text>
          </TaxonomyWrapper>

          {index === taxonomies.length - 1 && onFetchTaxonomies && (
            <InfiniteScroll onInfiniteScroll={onFetchTaxonomies} absolute={false} />
          )}
        </React.Fragment>
      ))}
      {!!loading && <Spinner />}
    </TaxonomiesWrapper>
  );
};

export default BrandProductsTaxonomyChangeModalTaxonomyList;
